import { Box } from '@pets-ui/Box/Box'
import { ButtonBase } from '@pets-ui/ButtonBase/ButtonBase'
import { ArrowDownLarge } from '@pets-ui/icons'
import { Image } from '@pets-ui/Image/Image'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'

const SELECTED_LABEL = '已選擇：'

const styles = stylex.create({
  root: {
    margin: 0,
    alignItems: 'center',
    columnGap: '8px',
    display: 'flex',
    width: '100%',
  },
  ribbon: {
    position: 'absolute',
    transform: 'rotate(-45deg) translate(-25%, -50%)',
    zIndex: 1,
    left: 0,
    right: '20%',
    top: 0,
  },
  icon: {
    marginLeft: 'auto',
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
})

export interface StmCollapseProductButtonProps {
  id: string
  thumbnail: string
  title: string
  countProduct: number
  showProductSalesTag?: boolean
  showProductNewTag?: boolean
  open?: boolean
  onClick?: () => void
}

export const StmCollapseProductButton = (props: StmCollapseProductButtonProps) => {
  const { id, thumbnail, title, countProduct, showProductSalesTag, showProductNewTag, open, onClick } = props

  return (
    <ButtonBase id={id} onClick={onClick} disableRipple rootStyle={styles.root}>
      <Box position="relative" overflow="hidden" width={80} height={80} flexShrink={0}>
        {showProductNewTag
          ? (
            <Box backgroundColor={colors.violet600} rootStyle={styles.ribbon}>
              <Text variant="caption" align="center" color={colors.white}>new</Text>
            </Box>
          )
          : showProductSalesTag && (
            <Box backgroundColor={colors.red600} rootStyle={styles.ribbon}>
              <Text variant="caption" align="center" color={colors.white}>Sale</Text>
            </Box>
          )}
        <Image
          width={80}
          height={80}
          src={thumbnail}
          alt={title}
          loading="lazy"
          loadingFallback={<Skeleton width={80} height={80} />}
        />
      </Box>
      <VStack flex={1} alignItems="flex-start" justifyContent="center">
        <Text component="h4" fontWeight={600}>{title}</Text>
        {countProduct > 0 && (
          <Text variant="caption" color={colors.green400}>
            {`${SELECTED_LABEL}${countProduct}`}
          </Text>
        )}
      </VStack>
      <ArrowDownLarge rootStyle={[styles.icon, open && styles.iconActive]} />
    </ButtonBase>
  )
}
